<template>
  <div>
    <div v-show="!msgError">
      <vue-pdf-app v-if="pdfData" :style="`height: ${height};`" :pdf="pdfData" :config="config"></vue-pdf-app>
    </div>
    <div class="invalid" v-show="msgError">
      <b-container>
        <b-row class="justify-content-center">
          <div class="attention-container">
            <div class="attention-container--outter-circle">
              <div class="attention-container--inner-circle">
                <i class="attention-container--icon fas fa-exclamation"></i>
              </div>
            </div>
          </div>
        </b-row>
        <b-row class="justify-content-center mt-5">
          <h5>
            {{ msgError }}
          </h5>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { inject } from "@vue/composition-api";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

export default {
  components: {
    VuePdfApp,
  },
  setup() {
    const globalLoading = inject("globalLoading");

    return { globalLoading };
  },
  props: {
    getDocumentHandler: {
      type: Function,
      required: true,
    },
    landscape: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "100vh",
    },
  },
  data() {
    return {
      pdfData: null,
      msgError: null,
      config: {
        toolbar: {
          toolbarViewerLeft: {
            openFile: false,
          },
          toolbarViewerRight: {
            viewBookmark: false,
          },
        },
        secondaryToolbar: {
          secondaryOpenFile: false,
          secondaryViewBookmark: false,
        },
      },
    };
  },
  mounted() {
    this.setDocument();
  },
  methods: {
    async setDocument() {
      try {
        this.globalLoading = true;
        const getDocumentHandler = this.$props.getDocumentHandler;

        if (!getDocumentHandler)
          throw Error("Invalid getDocumentHandler!", getDocumentHandler);

        const pdfData = await getDocumentHandler();

        if (!pdfData) {
          throw Error("Missing pdf data");
        }

        this.pdfData = pdfData;
        this.globalLoading = false;
      } catch (error) {
        if (error.message !== "Missing pdf data") {
          console.error(error);
        }
        this.globalLoading = false;
        this.msgError = "Arquivo Indisponível!";
        const submitBtn = document.getElementById("submitButtonText");
        if (submitBtn) {
          submitBtn.hidden = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #viewFind,
::v-deep #sidebarToggle,
::v-deep #openFile,
::v-deep #viewBookmark,
::v-deep #secondaryToolbarToggle {
  display: none !important;
}

.attention-container {
  &--icon {
    font-size: 4rem;
    color: white;
  }

  &--inner-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 7rem;
    width: 7rem;
    background: var(--yellow-1);
    border-radius: 100%;
  }

  &--outter-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 9rem;
    width: 9rem;
    background: var(--yellow-0);
    border-radius: 100%;
  }
}
</style>
<style>
.pdf-app .toolbar {
  z-index: 1 !important;
}
</style>
